import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            {mediaData.title}
          </h2>
          <p className="text-sm text-foreground-600">一区二区与每日大赛精选视频内容展示</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaData.items.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-500/90 rounded-full">
                    <i className="ri-play-fill text-xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded whitespace-nowrap">
                  {item.duration}
                </span>
                <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded whitespace-nowrap">
                  {item.zone}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 line-clamp-2 mb-2 leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}